// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .notifications-list {
  padding: 1rem;
}
:host .notifications-list .notification-item {
  margin-bottom: 16px;
  --border-width: 1px;
  --border-color: var(--ion-color-light);
  --padding-start: 0px;
  --inner-padding-end: 0px;
  align-items: flex-start;
  position: relative;
  z-index: 10;
  display: flex;
  flex-direction: column;
  overflow: visible;
  --border-radius: 5px;
}
:host .notifications-list .notification-item.viewed .notification-content .notification-text {
  color: var(--ion-color-medium);
}
:host .notifications-list .notification-item.viewed .notification-badge {
  display: none;
}
:host .notifications-list .notification-item.viewed .notification-footer .notification-sender {
  color: var(--ion-color-medium);
}
:host .notifications-list .notification-item.viewed .notification-footer .notification-sender span {
  color: var(--ion-color-medium);
}
:host .notifications-list .notification-item::part(native) {
  position: relative;
  z-index: 10;
}
:host .notifications-list .notification-item:after {
  height: calc(100% + 16px);
  width: 2px;
  background: var(--ion-color-light);
  left: calc(50% - 1px);
  content: "";
  position: absolute;
  z-index: 1;
}
:host .notifications-list .notification-item:last-of-type::after {
  display: none;
}
:host .notifications-list .notification-item .notification-content {
  margin: 0;
  margin-top: 0px;
  z-index: 10;
  position: relative;
}
:host .notifications-list .notification-item .notification-content ion-thumbnail {
  border-radius: 5px;
  margin-right: 10px;
}
:host .notifications-list .notification-item .notification-content .notification-text {
  padding: 10px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
:host .notifications-list .notification-item .notification-content .notification-text h3 {
  white-space: normal;
  font-size: 16px !important;
  font-weight: bold;
}
:host .notifications-list .notification-item .notification-content .notification-text h2 {
  white-space: normal;
  font-weight: bold;
}
:host .notifications-list .notification-item .notification-content .notification-text p {
  white-space: normal;
  line-height: 1.4;
  font-size: 14px !important;
}
:host .notifications-list .notification-item .notification-badge {
  width: 16px;
  height: 16px;
  display: inline-block;
  background-color: var(--ion-color-danger);
  border-radius: 50%;
  position: absolute;
  top: -8px;
  right: -8px;
  z-index: 20;
}
:host .notifications-list .notification-item .notification-footer {
  font-size: 14px !important;
  border-top: 1px solid var(--ion-color-light);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: var(--ion-color-medium);
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 1rem;
  padding-right: 1rem;
}
:host .notifications-list .notification-item .notification-footer .notification-sender span {
  color: var(--ion-color-dark);
}

:host-context(.plt-desktop) .notifications-list .notification-item:hover {
  cursor: pointer;
  opacity: 0.7;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/notify/notify.scss"],"names":[],"mappings":"AACE;EACE,aAAA;AAAJ;AACI;EACE,mBAAA;EACA,mBAAA;EACA,sCAAA;EACA,oBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,oBAAA;AACN;AAGU;EACE,8BAAA;AADZ;AAIQ;EACE,aAAA;AAFV;AAKU;EACE,8BAAA;AAHZ;AAIY;EACE,8BAAA;AAFd;AAQM;EACE,kBAAA;EACA,WAAA;AANR;AASM;EACE,yBAAA;EACA,UAAA;EACA,kCAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;AAPR;AAWQ;EACE,aAAA;AATV;AAaM;EACE,SAAA;EACA,eAAA;EACA,WAAA;EACA,kBAAA;AAXR;AAaQ;EACE,kBAAA;EACA,kBAAA;AAXV;AAcQ;EACE,aAAA;EACA,aAAA;EACA,2BAAA;EACA,uBAAA;AAZV;AAaU;EACE,mBAAA;EACA,0BAAA;EACA,iBAAA;AAXZ;AAcU;EACE,mBAAA;EACA,iBAAA;AAZZ;AAeU;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;AAbZ;AAkBM;EACE,WAAA;EACA,YAAA;EACA,qBAAA;EACA,yCAAA;EACA,kBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAhBR;AAmBM;EACE,0BAAA;EACA,4CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;EACA,kBAAA;EACA,mBAAA;AAjBR;AAoBU;EACE,4BAAA;AAlBZ;;AA6BM;EACE,eAAA;EACA,YAAA;AA1BR","sourcesContent":[":host {\n  .notifications-list {\n    padding: 1rem;\n    .notification-item {\n      margin-bottom: 16px;\n      --border-width: 1px;\n      --border-color: var(--ion-color-light);\n      --padding-start: 0px;\n      --inner-padding-end: 0px;\n      align-items: flex-start;\n      position: relative;\n      z-index: 10;\n      display: flex;\n      flex-direction: column;\n      overflow: visible;\n      --border-radius: 5px;\n\n      &.viewed {\n        .notification-content {\n          .notification-text {\n            color: var(--ion-color-medium);\n          }\n        }\n        .notification-badge {\n          display: none;\n        }\n        .notification-footer {\n          .notification-sender {\n            color: var(--ion-color-medium);\n            span {\n              color: var(--ion-color-medium);\n            }\n          }\n        }\n      }\n\n      &::part(native) {\n        position: relative;\n        z-index: 10;\n      }\n\n      &:after {\n        height: calc(100% + 16px);\n        width: 2px;\n        background: var(--ion-color-light);\n        left: calc(50% - 1px);\n        content: '';\n        position: absolute;\n        z-index: 1;\n      }\n\n      &:last-of-type {\n        &::after {\n          display: none;\n        }\n      }\n\n      .notification-content {\n        margin: 0;\n        margin-top: 0px;\n        z-index: 10;\n        position: relative;\n\n        ion-thumbnail {\n          border-radius: 5px;\n          margin-right: 10px;\n        }\n\n        .notification-text {\n          padding: 10px;\n          display: flex;\n          justify-content: flex-start;\n          align-items: flex-start;\n          h3 {\n            white-space: normal;\n            font-size: 16px !important;\n            font-weight: bold;\n          }\n\n          h2 {\n            white-space: normal;\n            font-weight: bold;\n          }\n\n          p {\n            white-space: normal;\n            line-height: 1.4;\n            font-size: 14px !important;\n          }\n        }\n      }\n\n      .notification-badge {\n        width: 16px;\n        height: 16px;\n        display: inline-block;\n        background-color: var(--ion-color-danger);\n        border-radius: 50%;\n        position: absolute;\n        top: -8px;\n        right: -8px;\n        z-index: 20;\n      }\n\n      .notification-footer {\n        font-size: 14px !important;\n        border-top: 1px solid var(--ion-color-light);\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n        color: var(--ion-color-medium);\n        padding-top: 10px;\n        padding-bottom: 10px;\n        padding-left: 1rem;\n        padding-right: 1rem;\n\n        .notification-sender {\n          span {\n            color: var(--ion-color-dark);\n          }\n        }\n      }\n    }\n  }\n}\n\n:host-context(.plt-desktop) {\n  .notifications-list {\n    .notification-item {\n      &:hover {\n        cursor: pointer;\n        opacity: 0.7;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
